import React from 'react'

function CloseIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      {...props}
    >
      <path
        fill="#444448"
        d="m17.252 15.999 3.82-3.81a.892.892 0 0 0-1.262-1.262L16 14.747l-3.81-3.82a.892.892 0 0 0-1.261 1.261l3.819 3.81-3.82 3.81a.889.889 0 0 0 .29 1.456.889.889 0 0 0 .972-.194L16 17.25l3.81 3.82a.889.889 0 0 0 1.456-.29.888.888 0 0 0-.195-.971l-3.819-3.81Z"
      />
    </svg>
  )
}

export default CloseIcon
